import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconItalic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconItalic"><Path fillRule="evenodd" clipRule="evenodd" d="M8.91379 3.5C8.91379 3.22386 9.13765 3 9.41379 3H19.5C19.7761 3 20 3.22386 20 3.5C20 3.77614 19.7761 4 19.5 4H14.8741L10.1682 20H14.5862C14.8624 20 15.0862 20.2239 15.0862 20.5C15.0862 20.7761 14.8624 21 14.5862 21H4.5C4.22386 21 4 20.7761 4 20.5C4 20.2239 4.22386 20 4.5 20H9.12588L13.8318 4H9.41379C9.13765 4 8.91379 3.77614 8.91379 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconItalic;
